export enum ReportType {
    InteractiveReport = 0,
    PathfinderReport = 1,
}
